import { cn } from "@/lib/utils";

interface PillButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  bgColor?: string;
  borderGradient?: string;
  className?: string;
  innerClassName?: string;
}

export default function PillButton({
  children,
  bgColor = "bg-foreground",
  borderGradient = "bg-gradient-dark",
  className,
  innerClassName,
  ...props
}: PillButtonProps) {
  return (
    <button
      {...props}
      className={cn(
        "text-white rounded-full p-0.25 bg-gradient-dark cursor-pointer text-nowrap",
        borderGradient,
        className
      )}
    >
      <div
        className={cn(
          "bg-foreground p-3 rounded-full",
          bgColor,
          innerClassName
        )}
      >
        {children}
      </div>
    </button>
  );
}
